import ProcessList from './ProcessList'
import './MultiProcessList.css'

const ProcessListWithoutManager = () => {
  return (
    <div className='multi_processList'>
      <h1 className='processList_row--header'>PROCESSER UTAN MANAGER</h1>
      <ProcessList endpoint={'Processes/WithoutManager'} process={"withoutManager"} filter={{ excludeFinished: false, onlyFinished: false }} />
    </div>
  )
}

export default ProcessListWithoutManager
